import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import { Title } from "@components/_Revamp/Typography/Title.stories";
import InnerContainer from "@components/_Revamp/InnerContainer";
import { css } from "@linaria/core";
import { ROUTE_PATH } from "@static/route-paths";
import Button from "@components/_Revamp/Button";
import React, { useEffect, useState } from "react";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import RadioInput from "@components/_Revamp/RadioInput";
import { themeDefault } from "src/theme-revamp";
import { updateUnderWriting2 } from "@redux/slices/CCP/step3Slice";
import { SCREEN_SIZE } from "@static/screen-size";
import Modal from "@components/_Revamp/Modal";
import { useHistory } from "react-router-dom";
import Text from "@components/Text";
import {
  NotificationBox,
  NotificationContent,
} from "@components/_Revamp/NotificationBox";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";
import { CCP_STEP_LIST } from "@static/content";
import { ContainerWithStepper } from "@pages/CCP/components/ContainerWithStepper";
import { useScreenSize } from "@pages/CCP/Hooks/useScreenSize";

function UnderWriting2() {
  const uw2 = useAvivaSelector((state) => state.cancerCoverStep3.underWriting2);
  const {
    isBenignGrowths,
    isColonPolyps,
    isBreastGrowths,
    isRecurrence,
    isTreatment,
    isOtherBenignGrowths,
  } = useAvivaSelector((state) => state.cancerCoverStep3.underWriting1);
  const uw1Values = [
    // isBenignGrowths,
    // isColonPolyps,
    // isBreastGrowths,
    isRecurrence,
    isTreatment,
    isOtherBenignGrowths,
  ];
  const [showModal, setShowModal] = useState(false);
  const [disableNext, setDisableNext] = useState(false);
  const dispatch = useAvivaDispatch();
  const history = useHistory();
  const basicInfo = useAvivaSelector(
    (state) => state.cancerCoverStep1.basicInfo
  );
  const { isMobile } = useScreenSize();
  const onNextClick = () => {
    if (disableNext) {
      setShowModal(true);
    } else if (uw2.result || uw2.doneScreening === "NO") {
      history.push(ROUTE_PATH.CANCER_COVER_UW_3);
      trackOnCTA({ ctaText: "Next", ctaType: "qb:link" });
    }
  };
  useEffect(() => {
    if (uw2.doneScreening === "YES") {
      if (
        (uw2.result === "ABNORMAL" &&
          (uw2.abnormalResult === null || uw2.abnormalResult === "YES")) ||
        uw2.result === "AWAITING"
      ) {
        setDisableNext(true);
      } else if (uw2.result === "NORMAL") {
        setDisableNext(false);
      }

      if (uw2.result === "ABNORMAL" && uw2.abnormalResult === "YES") {
        const uw1Yes = uw1Values.some((v) => v === "YES");
        const uw1No = uw1Values.every((v) => v === "NO");

        if (isBenignGrowths === "NO") {
          setDisableNext(true);
        } else if (
          isColonPolyps === "YES" ||
          isBreastGrowths === "YES" ||
          isOtherBenignGrowths === "YES"
        ) {
          setDisableNext(true);
          return;
        } else if (isBenignGrowths === "YES" && uw1No) {
          setDisableNext(true);
        } else if (uw1Yes) {
          setDisableNext(false);
        } else {
          setDisableNext(false);
        }
      }

      if (uw2.result === "ABNORMAL" && uw2.abnormalResult === "NO") {
        setDisableNext(true);
      }

      if (uw2.result === null) {
        setDisableNext(true);
      }
    } else if (uw2.doneScreening === "NO") {
      setDisableNext(false);
    } else if (uw2.doneScreening === null) {
      dispatch(updateUnderWriting2({ doneScreening: "NO" }));
    }
  }, [uw2]);

  //AA Page Loading
  useEffect(() => {
    trackOnLoad();
  }, []);

  useEffect(() => {
    if (showModal) {
      trackOnLoad();
    }
  }, [showModal]);
  return (
    <>
      <ContainerWithStepper
        currentStep={ROUTE_PATH.CANCER_COVER_UW_1A}
        className={containerStyle}
        backButtonPath={ROUTE_PATH.CANCER_COVER_UW_1B}
      >
        <div id="uw-container">
          <InnerContainer className={UWStyle}>
            <h3>
              {basicInfo?.forwhom === "myself"
                ? "Have you been advised or intend to undergo any of the following, apart from routine age-related screenings with normal results?"
                : "Has your child been advised or intend to undergo any of the following, apart from routine age-related screenings with normal results?"}
            </h3>
            <div>
              <section>
                <ul>
                  <li>Biopsy</li>
                  <li>Colonoscopy</li>
                  <li>CT/MRI/PET Scan</li>
                  <li>Endoscopy</li>
                  <li>Mammography</li>
                  <li>Pap smear</li>
                  <li>Tumour markers</li>
                  <li>Ultrasound</li>
                  <li>
                    OR had any investigations/tests which were abnormal and/or
                    required monitoring?
                  </li>
                </ul>
              </section>
              <div id="notificationbox">
                {isMobile ? (
                  <Text className={MessageBoxParagraphCss}>
                    For scans done due to injury or heart disease (e.g. heart
                    valve disorder), please select No.
                  </Text>
                ) : (
                  <NotificationBox
                    margin={"0 0"}
                    background="#f5f5f5"
                    boxShadow="none"
                    padding="12px"
                    className={messageBoxStyle}
                  >
                    <NotificationContent
                      iconFill="white"
                      backgroundFill="#434343"
                    >
                      <Text className={MessageBoxParagraphCss}>
                        For scans done due to injury or heart disease (e.g.
                        heart valve disorder), please select No.
                      </Text>
                    </NotificationContent>
                  </NotificationBox>
                )}
              </div>
              <div>
                <Button
                  onClick={() => {
                    dispatch(updateUnderWriting2({ doneScreening: "YES" }));
                  }}
                  disabled={false}
                  label={"Yes, at least one"}
                  hoverBgColor={themeDefault.colors.primary}
                  hoverTextColor="#FFF"
                  textColor={
                    uw2.doneScreening === "YES" ? "#FFFFFF" : "#8A8988"
                  }
                  bgColor={
                    uw2.doneScreening === "YES"
                      ? themeDefault.colors.primary
                      : "#F5F5F5"
                  }
                  borderColor="#F5F5F5"
                />

                <Button
                  disabled={false}
                  onClick={() => {
                    dispatch(updateUnderWriting2({ doneScreening: "NO" }));
                  }}
                  label={"No, none of the above"}
                  hoverBgColor={themeDefault.colors.primary}
                  hoverTextColor="#FFF"
                  textColor={uw2.doneScreening === "NO" ? "#FFFFFF" : "#8A8988"}
                  bgColor={
                    uw2.doneScreening === "NO"
                      ? themeDefault.colors.primary
                      : "#F5F5F5"
                  }
                  borderColor="#F5F5F5"
                />
              </div>
            </div>
          </InnerContainer>

          {uw2.doneScreening === "YES" && (
            <InnerContainer className="uw2result-style">
              <h3>What were the results?</h3>
              <RadioInput
                name="uw2result"
                onClick={(e: any) => {
                  dispatch(
                    updateUnderWriting2({
                      result: "NORMAL",
                    })
                  );
                }}
                value={"NORAML"}
                checked={uw2.result === "NORMAL"}
              >
                Normal
              </RadioInput>
              <RadioInput
                name="uw2result"
                onClick={(e: any) => {
                  console.info(e.target);
                  dispatch(
                    updateUnderWriting2({
                      result: "ABNORMAL",
                    })
                  );
                  if (!uw2.abnormalResult) {
                    dispatch(
                      updateUnderWriting2({
                        abnormalResult: "YES",
                      })
                    );
                  }
                }}
                value={"ABNORMAL"}
                checked={uw2.result === "ABNORMAL"}
              >
                Abnormal or requiring monitoring
              </RadioInput>
              <RadioInput
                name="uw2result"
                onClick={(e: any) => {
                  dispatch(
                    updateUnderWriting2({
                      result: "AWAITING",
                    })
                  );
                  // setShowModal(true);
                }}
                value={"AWAITING"}
                checked={uw2.result === "AWAITING"}
              >
                Awaiting results
              </RadioInput>
            </InnerContainer>
          )}
          {uw2.result === "ABNORMAL" && uw2.doneScreening === "YES" && (
            <InnerContainer className="result-style">
              <h3>
                {basicInfo?.forwhom === "myself"
                  ? "Are the abnormal results referring to one of your conditions disclosed at the start of this questionnaire?"
                  : "Are the abnormal results referring to one of your child's conditions disclosed at the start of this questionnaire?"}
              </h3>
              <div>
                <Button
                  disabled={false}
                  label={"Yes"}
                  hoverBgColor={themeDefault.colors.primary}
                  bgColor={
                    uw2.abnormalResult === "YES"
                      ? themeDefault.colors.primary
                      : "#F5F5F5"
                  }
                  borderColor="none"
                  textColor={
                    uw2.abnormalResult === "YES" ? "#FFFFFF" : "#8A8988"
                  }
                  onClick={() => {
                    dispatch(
                      updateUnderWriting2({
                        abnormalResult: "YES",
                      })
                    );
                    // const uw1Yes = uw1Values.every((v) => v === "NO");
                    // if (uw1Yes || isBenignGrowths === "NO") {
                    //   setShowModal(true);
                    // }
                  }}
                />
                <Button
                  disabled={false}
                  label={"No"}
                  hoverBgColor={themeDefault.colors.primary}
                  bgColor={
                    uw2.abnormalResult === "NO"
                      ? themeDefault.colors.primary
                      : "#F5F5F5"
                  }
                  textColor={
                    uw2.abnormalResult === "NO" ? "#FFFFFF" : "#8A8988"
                  }
                  borderColor="none"
                  onClick={() => {
                    dispatch(
                      updateUnderWriting2({
                        abnormalResult: "NO",
                      })
                    );
                  }}
                />
              </div>
            </InnerContainer>
          )}
          <div
            className={`next-btn ${
              disableNext && !uw2.result && "disabledBtn"
            }`}
          >
            <Button
              disabled={disableNext && !uw2.result}
              label={"Next"}
              hoverBgColor={themeDefault.colors.primary}
              onClick={onNextClick}
            />
          </div>
        </div>
      </ContainerWithStepper>
      {showModal && (
        <Modal
          show={showModal}
          className={modalStyle}
          onClose={() => {
            setShowModal(false);
          }}
        >
          <Title variant="title" align="center">
            You may need some assistance
          </Title>
          <p>
            It looks like you might need assistance from a Financial Adviser
            Representative to find a more suitable plan for your needs.
          </p>
          <div>
            <Button
              disabled={false}
              label={"Contact us"}
              onClick={() => {
                history.push(ROUTE_PATH.CANCER_COVER_CONTACT_US);
                trackOnCTA({ ctaText: "Contact Us", ctaType: "qb:link" });
              }}
            />
          </div>
        </Modal>
      )}
    </>
  );
}

export default UnderWriting2;

const modalStyle = css`
  .modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    & > div {
      width: 100%;
    }
  }
  p:nth-child(2) {
    color: #8a8988;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    line-height: 19.6px;
    margin-bottom: 48px;
  }

  button {
    width: 100%;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 1.28px;
    line-height: 22.4px;
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      & > div {
        max-width: 180px;
        width: 100%;
      }
    }
    button {
      max-width: 180px;
    }
  }
`;

const messageBoxStyle = css`
  div:first-child {
    align-items: center;
  }
`;

const MessageBoxParagraphCss = css`
  font-style: normal;
  line-height: 180%;
  color: #434343 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 14px !important;
    font-weight: 500 !important;
  }
`;

const containerStyle = css`
  #uw-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .disabledBtn {
    button {
      background-color: #d4bfd7;
      color: #f7f9fb;
    }
  }

  .next-btn {
    display: flex;
    justify-content: center;
    button {
      max-width: 200px;
    }
  }
  h3 {
    font-size: 18px;
    font-weight: 600;
    line-height: 25.2px;
    max-width: 664px;
  }
  .uw2result-style {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .result-style {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 24px;
    div {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: 8px;
      button {
        width: 100%;
        max-width: 328px;
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
      }
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .uw2result-style {
      padding: 24px 64px;
    }

    .result-style {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      div {
        flex-direction: row;
        button {
          font-size: 12px;
        }
      }
    }
  }
`;

const UWStyle = css`
  display: flex;
  flex-direction: column;
  gap: 36px;
  h3 {
    font-size: 18px;
    font-weight: 600;
    line-height: 25.2px;
  }
  div {
    display: flex;
    flex-direction: column;
    gap: 24px;

    & > div {
      display: flex;
      flex-direction: column;
      gap: 8px;
      button {
        width: 100%;
        max-width: 328px;
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
      }
    }
    #notificationbox {
      div {
        display: flex;
        flex-direction: row;
      }
    }
    .notification {
      flex-direction: row;
    }

    section > ul {
      display: grid;
      gap: 16px;
      margin-left: 14px;
      font-size: 14px;
      font-weight: 500;
      line-height: 22.4px;
      color: #434343;
    }
    & > p {
      color: #8a8988;
      font-size: 12px;
      font-weight: 600;
      line-height: 16.8px;
    }
    button:hover {
      box-shadow: none;
    }
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 24px 64px;
    div {
      flex-direction: column;
      gap: 24px;

      & > div {
        flex-direction: row;
        button {
          font-size: 12px;
        }
      }

      section > ul {
        grid-template-columns: repeat(2, 1fr);
        li:last-child {
          grid-column-start: 1;
          grid-column-end: 3;
        }
      }
    }
  }
`;
